import React, { useEffect, useRef, useState } from 'react';
import WebButton from '../../../../library/webButton';
import { ProductSubscriptionApiService } from '../../../../../service/seller/productSubscriptionApiService';
import { useLoader } from '../../../../../base/context/LoaderProvider';
import { ToastTypes, useMessage } from '../../../../../base/context/MessageProvider';
import { useOutsideClick } from '../../../../../base/context/OutsideClick';
import { RiArrowDropDownLine } from 'react-icons/ri';
import './style.css';

export default function DataExport({ selectedSKUs, setSelectedSKUs, setSelectAll }) {
  const [showOptions, setShowOptions] = useState(false);

  const loader = useLoader();
  const message = useMessage();
  const outsideClick = useOutsideClick();
  const ref = useRef(null);

  const options = [
    { name: 'Shopify Template', value: 'shopify template' },
    { name: 'Amazon Template', value: 'amazon template' },
    { name: 'Product Listing', value: 'product listing' },
    { name: 'Amazon Image', value: 'amazon image' },
    { name: 'Shopify Image', value: 'shopify image' },
    { name: 'Image Zip', value: 'image zip' },
  ];

  const handleOptions = () => {
    setShowOptions(!showOptions);
  };

  const handleExport = async type => {
    if (!selectedSKUs.length) {
      setShowOptions(false);
      return message.showToast('Select at least one product', ToastTypes.ERROR);
    }

    loader.showLoading(true);
    const toastId = message.showToast(`Processing Export ${type} data, please wait...`, ToastTypes.LOADING);

    const skuList = selectedSKUs.map(item => typeof item === 'object' ? item.sku : item);
    const productPayload =
      type === 'amazon template' || type === 'image zip' ? { skus: skuList } : { skus: skuList, type };

    const apiCall =
      type === 'image zip'
        ? ProductSubscriptionApiService.exportSubscribeProductInImage
        : type === 'amazon template'
          ? ProductSubscriptionApiService.exportAmazonProduct
          : ProductSubscriptionApiService.exportSubscribeProduct;

    try {
      const res = await apiCall(JSON.stringify(productPayload));
      loader.showLoading(false);

      if (res.status.code === 200) {
        message.showToast('Export successful.', ToastTypes.SUCCESS, { toastId });

        setSelectedSKUs([]);
        setSelectAll(false);
        setShowOptions(false);

        // Amazon template handles its own download via blob
        if (!res.data?.directDownload) {
          const url = res.data.url;
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'products.csv');
          link.click();
        }
      } else {
        message.showToast(res.error.message, ToastTypes.ERROR, { toastId });
      }
    } catch (err) {
      loader.showLoading(false);
      setShowOptions(false);
      message.showToast(err?.message || 'Server error. Try again later', ToastTypes.ERROR);
    }
  };

  const onClickOutside = () => {
    setShowOptions(false);
  };

  useEffect(() => {
    outsideClick.getComponent(ref, onClickOutside);
  }, [onClickOutside]);

  return (
    <div className="relative">
      <div onClick={() => handleOptions()} className="filter_dropdown export_dropdown_btn">
        Data Export <RiArrowDropDownLine className="export_dropdown_icon" />
      </div>

      {showOptions ? (
        <div
          ref={ref}
          className={`${
            showOptions ? 'w-60 h-auto' : null
          } z-[1] h-0 bg-white border absolute shadow-xl flex flex-col gap-4 p-4`}
        >
          {options.map((item, key) => {
            return (
              <p key={key} className="cursor-pointer font-medium" onClick={() => handleExport(item.value)}>
                {item.name}
              </p>
            );
          })}
        </div>
      ) : null}
    </div>
  );
}
